import { makeStyles } from "tss-react/mui"
import { blueGrey } from "../../../mp-core/themes/palette"
import { alpha, typographyClasses } from "@mui/material"

type StylesParams = {
  iconColor: string
  iconBgColor: string
}

export const useStyles = makeStyles<StylesParams>()(
  ({}, { iconColor, iconBgColor }) => ({
    container: {
      border: `1px solid ${blueGrey[100]}`,
      borderRadius: "3px",
      backgroundColor: alpha(blueGrey[50], 0.5),
      width: "100%",

      [`& .${typographyClasses.root}`]: {
        color: blueGrey[800]
      }
    },
    defaultIcon: {
      color: iconColor,
      backgroundColor: iconBgColor
    }
  })
)
